import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './Inovacao.scoped.scss';

class Inovacao extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template inovacao">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas à inovação se deram em cinco frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="inovacao planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_inovacao1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Construção do posicionamento para o tema inovação</h5>
                <p>
                  A Diretoria aprovou em novembro o Projeto Nexus, que traz diretrizes para que a ANBIMA trabalhe para
                  estimular a inovação no mercado de capitais. O plano foi produzido em parceria com o Grupo Consultivo
                  de Inovação e apoio de uma consultoria especializada. As iniciativas fazem parte do plano de
                  ação para 2021.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_inovacao2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Aperfeiçoamento da comunicação digital com o associado e demais stakeholders
                </h5>
                <p>
                  Os canais digitais, principalmente o Workplace e o WhatsApp, foram fortalecidos por conta da
                  quarentena: 70% dos associados já aderiram ao Workplace e o Whatsapp conta com mais de mil executivos
                  cadastrados.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_inovacao3} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Realização de estudo para mapear as novas formas de sugerir alocação de investimentos
                </h5>
                <p>
                  Nos últimos anos houve um aumento de influenciadores digitais recomendando investimentos, além dos
                  players tradicionais, como agentes e consultores. Contratamos uma consultoria para conduzir o
                  levantamento desses novos agentes com o objetivo de nortear a nossa atuação em relação ao assunto. O
                  trabalho foi finalizado.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_inovacao4} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Modernização do processo de precificação</h5>
                <p>
                  Em 2020, foram feitas as primeiras discussões com potenciais parceiros para o aprimoramento da coleta
                  e da divulgação de preços. Também conversamos com o mercado para definir o papel da ANBIMA junto aos
                  agentes precificadores. Essa iniciativa terá continuidade em 2021.
                </p>
                <p>
                  Para dar mais transparência à atividade, lançamos, em abril, o Relatório Diário de Precificação, com
                  estatísticas agregadas do processo de coleta, apuração e comparação dos preços de títulos públicos e
                  privados que formam as taxas médias da nossa precificação. Também aumentamos a quantidade de ativos
                  precificados e o número de instituições que participam da amostra de precificadores, expandindo a
                  representatividade da atividade.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_inovacao5} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Redesenhar o processo de certificação e educação continuada, ampliando sua oferta de valor para os
                  profissionais certificados
                </h5>
                <p>
                  Por conta da pandemia, o projeto deixou de ser prioridade. Paralelamente, foram tomadas outras ações,
                  como abertura da plataforma de cursos de forma gratuita para todos os interessados; lançamento de
                  novos cursos; e teve início a avaliação de soluções para aplicação de provas de certificação a
                  distância.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div> */}
      </div>
    );
  }
}
export { Inovacao };
